package com.essntl.features.service.data.supabase.supplierservice

import com.essntl.features.service.domain.model.supplierservice.SupplierServiceModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun SupplierServiceModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["supplier_id"] = JsonPrimitive(supplier.id)
    requestMap["service_id"] = JsonPrimitive(service.id)
    requestMap["organization_id"] = JsonPrimitive(organization.id)

    return requestMap
}